// ADR-132: MISC → Ingestion. Landing page for ingestion configuration.
// One card per configuration area, each behind its own permission. Sync run
// history is a report, not configuration: it lives in Reports (ADR-133).
import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import BadgeIcon from '@mui/icons-material/Badge';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, BackButton, Title, Content, MainSection } from '../common/styles';
import { StyledCard, StyledIconButton } from '../LandingPage/styles';
import { useAbility } from '../../contexts/AbilityContext';
import { ACTIONS, SUBJECTS } from '../../constants/permissions';

const configCards = [
  {
    id: 'job-position-mappings',
    title: 'Job Position Mappings',
    description: 'Map Americas and PowerBI job titles to Radar positions.',
    icon: <BadgeIcon />,
    path: '/ingestion/job-position-mappings',
    customIconStyle: {
      backgroundColor: '#3F51B5',
    },
    permission: {
      action: ACTIONS.READ,
      subject: SUBJECTS.INGESTION_CONFIGURATION,
    },
  },
];

const IngestionConfiguration = () => {
  const navigate = useNavigate();
  const ability = useAbility();

  const visibleCards = configCards.filter((card) => {
    if (!card.permission) {
      return true;
    }
    return ability.can(card.permission.action, card.permission.subject);
  });

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate('/')}>
            <FaArrowLeft /> Back to Home
          </BackButton>
          <Title>Ingestion</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <MainSection>
          <Typography variant="body1" paragraph>
            Configuration read by the Americas and PowerBI ingestion syncs
          </Typography>

          <Grid container spacing={3}>
            {visibleCards.map((card) => (
              <Grid item xs={12} md={6} key={card.id}>
                <StyledCard onClick={() => navigate(card.path)}>
                  <StyledIconButton
                    sx={{
                      ...card.customIconStyle,
                      '&:hover': {
                        ...card.customIconStyle,
                      },
                    }}
                  >
                    {card.icon}
                  </StyledIconButton>
                  <Typography variant="h6" align="center">{card.title}</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    {card.description}
                  </Typography>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        </MainSection>
      </Content>
    </Container>
  );
};

export default IngestionConfiguration;
